<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" (ngSubmit)="save()">
    <modal-header
      [plugin]="plugin"
      [menuModal]="menuModal"
      [isEditPage]="isEditPage"
      [menuComponent]="menuComponent"
      [pluginType]="'discussion'"
    ></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-stabilizer">
        <div class="ir-content--modal th-content th-content-customer">
          <table class="ir-modal-table">
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.comment.to' | translate }} *</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <div class="ir-line ir-select th-select" (click)="openTypesSelector(type)">
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span>{{
                        type != -1
                          ? (type | discussioncommenttype)
                          : ('plugins.customer-comments.select-comment-type' | translate)
                      }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <h2>
            <span>{{ 'plugins.comment.comment' | translate }} *</span>
          </h2>
          <div class="ir-form-group">
            <textarea
              name="comment"
              [(ngModel)]="comment"
              rows="6"
              placeholder="Your comment"
              class="ir-form-set"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #deleteCommentConfirm
  (confirmOutput)="deleteComment($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete comment?'"
  [danger]="true"
></confirm>
<modal (modalOutput)="selectTypesMenu($event)" (modalClosed)="onClose($event)" #typesModal></modal>
